'use client';
import { ArrowLeft } from 'lucide-react';

import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';

export default function GoBackButton() {
  const t = useTranslations('NotFound');
  const router = useRouter();

  const handleGoBack = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    router.back();
  };

  return (
    <Button variant='outline' className='border-white' onClick={handleGoBack}>
      <ArrowLeft className='h-4 w-4' />
      {t('go_back')}
    </Button>
  );
}
